"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@mui/material/styles/styled"));
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var general_1 = require("utils/general");
var LinkCopierButton = (0, styled_1.default)(LineButton_1.default, { shouldForwardProp: (0, general_1.omitProps)('isSingle') })(function (_a) {
    var theme = _a.theme, isSingle = _a.isSingle;
    return ({
        borderTopLeftRadius: isSingle ? undefined : 0,
        borderBottomLeftRadius: isSingle ? undefined : 0,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.body1.fontSize,
        padding: theme.spacing(0.5, 2),
        height: 28,
        lineHeight: '20px',
        whiteSpace: 'nowrap',
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(LinkCopierButton, {
    color: 'neutral',
    size: 'small',
});
